<template>
  <component :is="layout">
    <router-view />
  </component>

</template>

<script setup>
import { computed, onMounted } from 'vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { startRecord } from '@/common/rrwebRecorder';

const layout = computed(() => {
  return DefaultLayout
})

onMounted(() => {
  startRecord();
})
</script>

<style></style>
